import * as React from 'react';
import MainHeader from '../../headers/MainHeader/MainHeader';
import styles from './NoPageFound.module.scss'
import NoProjectFoundHeader from '../../pages/project/NoProjectFoundHeader/NoProjectFoundHeader';
import { Page } from '../Page/Page';
import { PageBody } from '../PageBody/PageBody';

function NoPageFound() {
    return (
        <Page>
            <MainHeader>
                <NoProjectFoundHeader />
            </MainHeader>
            <PageBody>
                <div className={styles.label}>
                    Page does not exist
                </div>
            </PageBody>

        </Page>
    );
}

export default NoPageFound;